export const TrashIcon = (ps: React.SVGAttributes<SVGElement>) => (
  <svg
    width="36"
    height="36"
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...ps}>
    <g clipPath="url(#clip0_1_2635)">
      <path
        d="M9 28.5C9 30.15 10.35 31.5 12 31.5H24C25.65 31.5 27 30.15 27 28.5V10.5H9V28.5ZM12.69 17.82L14.805 15.705L18 18.885L21.18 15.705L23.295 17.82L20.115 21L23.295 24.18L21.18 26.295L18 23.115L14.82 26.295L12.705 24.18L15.885 21L12.69 17.82ZM23.25 6L21.75 4.5H14.25L12.75 6H7.5V9H28.5V6H23.25Z"
        fill="#EE0000"
      />
    </g>
    <defs>
      <clipPath id="clip0_1_2635">
        <rect width="36" height="36" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
